import { render, staticRenderFns } from "./FooterMobileTab.vue?vue&type=template&id=f74d3b28&scoped=true&lang=pug&"
import script from "./FooterMobileTab.vue?vue&type=script&lang=js&"
export * from "./FooterMobileTab.vue?vue&type=script&lang=js&"
import style0 from "./FooterMobileTab.vue?vue&type=style&index=0&id=f74d3b28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f74d3b28",
  null
  
)

export default component.exports